<template>
  <GlobalNav>
    <div class="login-outer-container">
      <div class="center-middle overflow-container">
        <div class="middle-container">
          <Card :disableTitle="true">
            <div class="loader-area" v-if="isLoading">
              <loading-state :size="50" />
            </div>
            <div v-else class="login-container">
              <h1 class="container-title">Reset Password</h1>
              <ResetPasswordForm
                :auth-token="authToken"
                :request-id="requestId"
                :user-id="userId"
                @success="goToLogin"
              />
              <div class="login-links">
                <div class="forgot">
                  <router-link tabindex="6" to="login">Back to Login</router-link>
                </div>
              </div>
            </div>
          </Card>
        </div>
      </div>
    </div>
  </GlobalNav>
</template>

<script>
import { computed, onMounted } from "vue";
import Card from "@/components/display/Card";
import GlobalNav from "@/components/nav/GlobalNav";
import LoadingState from "@/components/display/LoadingState";
import ResetPasswordForm from "@/components/smart/forms/ResetPasswordForm";
import router from "@/router";
import store from "@/store";

export default {
  name: "ResetPassword",
  components: {
    Card,
    LoadingState,
    GlobalNav,
    ResetPasswordForm,
  },
  props: {
    userId: {
      type: [Number, String],
      required: true,
    },
  },
  setup() {
    const isLoading = computed(() => store.state.settings.status.isLoading);
    const authToken = computed(() => store.state.auth.resetToken);
    const requestId = computed(() => store.state.auth.resetRequestId);

    onMounted(() => {
      store.dispatch("settings/fetch");
    });

    const goToLogin = () => {
      store.dispatch("auth/clearPasswordReset");
      router
        .push({
          name: "login",
          query: {
            reason: "successful-password-reset", // notify the user that an email has been sent
          },
        })
        .catch(() => {});
    };

    return {
      goToLogin,
      isLoading,
      authToken,
      requestId,
    };
  },
};
</script>

<style lang="scss" scoped>
@import "~@/styles/variables";

.login-outer-container {
  display: flex;
  flex-direction: column;
  height: 100%;

  .overflow-container {
    overflow: auto;
    padding: 1rem 0;
  }
  .middle-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: auto;
    width: 100%;
    max-width: 360px;
    padding: 1rem;
  }
  .top-logo {
    max-width: 68%;
    width: 350px;
    margin-bottom: 1rem;
    text-align: center;
  }

  .loader-area {
    width: 100%;
    min-width: 300px;
    max-width: 350px;
    height: 350px;
    position: relative;
  }

  .login-container {
    min-width: 300px;
    padding: 1rem;

    .form-control {
      width: 100%;
    }

    .login-links {
      font-size: 0.75rem;
      text-align: center;
      .forgot {
        margin-bottom: 1rem;
      }
    }
  }
}
</style>
